const storage = sessionStorage

export default storage
